import {combineReducers} from "redux";
import {HotelState, hotelReducer} from "./hotels";
import {ConfigState, configReducer} from "./config";
import {securityReducer, SecurityState} from "./security";
import {ordersReducer, OrdersState} from "./orders";
import {discountsReducer, DiscountsState} from "./discounts";
import {ticketsReducer, TicketsState} from "./tickets";

export interface ApplicationState {
    hotels: HotelState;
    config: ConfigState;
    security: SecurityState;
    orders: OrdersState;
    discounts: DiscountsState;
    tickets: TicketsState;
}

export default combineReducers<ApplicationState>({
    hotels: hotelReducer,
    config: configReducer,
    security: securityReducer,
    orders: ordersReducer,
    discounts: discountsReducer,
    tickets: ticketsReducer,
});



// WEBPACK FOOTER //
// ./src/reducers/index.ts